import { AfterViewInit, Component, Input, OnChanges, OnInit } from '@angular/core';
import { DropdownFrameComponent } from '..';
import { FlagService, AgeGroupService, ToastService, DataService } from '@core/services';
import { APIClient } from 'src/app/modules/_services/api/@generated';
import { DatePipe } from '@angular/common';
import { faInfoCircle, faClipboardCheck, faFilePdf, faCheck } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { HIPContractDto } from '../../../modules/_services/api/@generated/models';
import moment from 'moment/moment';

@Component({
  selector: 'app-conditions-juncture',
  templateUrl: './conditions-juncture.component.html',
  styleUrls: ['./conditions-juncture.component.scss'],
  providers: [DatePipe],
  standalone: false
})

export class ConditionsJunctureComponent implements OnInit, AfterViewInit, OnChanges {
  faInfoCircle = faInfoCircle;
  faClipboardCheck = faClipboardCheck;
  faFilePdf = faFilePdf;
  faCheck = faCheck;

  @Input() lang: string; // to trigger onChanges..
  @Input() HIPContractDto: HIPContractDto;

  offerChoicesArray = [];
  choosenOfferRisks = [];

  koopFrameContractId: string;

  contractStartDate: string;

  public errorMessage = '';
  public documentIsOK = false;
  public conditionCounter = 0;

  public adatvedelemLink = '<a href="https://union.hu/adatvedelem" target="_blank">https://union.hu/adatvedelem</a>';

  public customerType1 = '';
  public customerType2 = '';

  constructor(public dropdownFrame: DropdownFrameComponent,
              public flagService: FlagService,
              public ageGroupService: AgeGroupService,
              public toastService: ToastService,
              public dataService: DataService,
              private translate: TranslateService,
              private api: APIClient) { }

  ngOnInit(): void {
    this.koopFrameContractId = JSON.parse(sessionStorage.getItem('HIPContract')).koopFrameContractId;

    const customStartDate: string = sessionStorage.getItem('customStartDate');
    if (customStartDate === 'true') {
      this.contractStartDate = moment().add(1, 'day').format('YYYY-MM-DD');
    } else {
      this.contractStartDate = this.dataService.HIPInsuredPersonFromHIPDto.riskStartDate || '';
    }

    this.offerChoicesArray = JSON.parse(sessionStorage.getItem('offerChoices'));

    for (const i in this.offerChoicesArray) {
      if (this.offerChoicesArray[i].displayName === this.dataService.HIPInsuredPersonFromHIPDto.contractGroupName) {
        this.choosenOfferRisks = this.offerChoicesArray[i].first_level_risks;
        break;
      }
    }
  }

  ngOnChanges(): void {
    if (this.HIPContractDto) {
      this.customerType1 = this.translate.store.currentLang === 'en' ?
        this.HIPContractDto.hipCustomerType.customerTypeEnglish :
        this.HIPContractDto.hipCustomerType.customerType;
      this.customerType2 = this.translate.store.currentLang === 'en' ?
        this.HIPContractDto.hipCustomerType.customerTypeGenitiveEnglish :
        this.HIPContractDto.hipCustomerType.customerTypeGenitive;
    }
  }

  ngAfterViewInit(): void {
    window.scrollTo(0, this.dataService.fixInfoContainerHeight + 395 + (this.dataService.isPartneri() ? 55 : 0) + (this.dataService.isKompakt() ? 0 : 60));
  }

  public getPdfDocument(id: number): void {
    this.api.getDocuments({
      koopFrameContractId: this.koopFrameContractId,
      contractGroupId: this.dataService.HIPInsuredPersonFromHIPDto.contractGroupId
    }).subscribe((rs) => {
      const byteArray = this.createByteArrayFromBase64(rs.fileContentInByte);
      this.createLink(byteArray, rs.fileName, id);
      this.documentIsOK = true;
    }, (error) => {
      this.toastService.initializeMessage(error.error.message, 'error');
    });
  }

  private createByteArrayFromBase64(base64String: string): Uint8Array {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    return byteArray;
  }

  private createLink(file: any, fileName: string, fileId: number): void {
    const blob = new Blob([file], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    // download or open depending on linkType
    // this.DataService.connectionLinkType === "HOZZATARTOZOI"? link.download = fileName : null;
    link.download = this.dataService.selectedLanguage === 'en' ? 'Contract_documents.pdf' : 'szerzodes_dokumentumai.pdf';
    link.style.display = 'none';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public checkCondition(event: any): void {
    if (event.target.checked) {
      this.conditionCounter++;
    } else {
      this.conditionCounter--;
    }
  }

  public getAllConditionsNumber(): number {
    const child = this.ageGroupService.choosenAgeGroup[0].id === '02' ? 1 : 0;

    if (this.dataService.connectionLinkType === 'KOMPAKT_HOZZATARTOZOI') {
      return 12 + child;
    }
    if (this.dataService.connectionLinkType === 'KOMPAKT_PARTNERI') {
      return 11 + child;
    }

    // nem kompakt esetén
    return 5 + child;
  }

  public conditionsJunctureClick(): void {
    this.errorMessage = '';
    if (this.documentIsOK && this.conditionCounter === this.getAllConditionsNumber()) {
      this.dropdownFrame.junctureClick('captchaJunctureFlag', 8);
    } else {
      if (!this.documentIsOK) {
        // this.errorMessage = 'Kérjük, hogy töltsd le és olvasd el a dokumentumokat, majd fogadd el a nyilatkozatokat!';
        this.errorMessage = this.translate.instant('missing.condition.error1');
        // this.toastService.initializeMessage('Tovább haladáshoz szükséges a dokumentum letöltése és megtekintése', 'error');
      } else {
        // this.errorMessage = 'Kérjük, hogy fogadd el a nyilatkozatokat!';
        this.errorMessage = this.translate.instant('missing.condition.error2');
        // this.toastService.initializeMessage('Tovább haladáshoz szükséges az összes feltétel elfogadása', 'error');
      }
    }
  }

}
